<template>
    <div class="order-form-main">
        <h3>Client Information:</h3>
        <div class="row">
            <div class="col-sm-6">
                <div class="row">
                    <ValidationProvider class="col-sm-12" name="First Name" rules="required|alpha_spaces|min:1|max:20" v-slot="{ errors }">
                        <div class="form-group">
                            <label for="first_name" :class="['form-label']">
                                First Name*
                            </label>
                            <input
                                type="text"
                                id="first_name"
                                placeholder="First Name"
                                :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                v-model="form.first_name"
                            >

                            <div :class="['form-group field-validation-error']">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12" name="Last Name" rules="required|alpha_spaces|min:1|max:20" v-slot="{ errors }">
                        <div class="form-group">
                            <label for="last_name" :class="['form-label']">
                                Last Name*
                            </label>
                            <input
                                type="text"
                                id="last_name"
                                placeholder="First Name"
                                :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                v-model="form.last_name"
                            >

                            <div :class="['form-group field-validation-error']">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12" name="Email" rules="required|email" v-slot="{ errors }">
                        <label for="email" class="form-label">Email Address:*</label>
                        <div class="form-group">
                            <input id="email" type="email" :class="['form-control mb-1', {'input-error' : errors[0] }]" v-model="form.email"
                                   placeholder="Email">

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] }]">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12" name="Phone" vid="Phone" rules="required|min:10|max:14" v-slot="{ errors }">
                        <label for="phone" class="form-label">Phone Number:*</label>
                        <div class="form-group mb-0">
                            <the-mask
                                type="tel"
                                id="phone"
                                :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                mask="+1 (###) ###-####"
                                v-model="form.phone"
                            >
                            </the-mask>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] }]">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="row">
                    <div class="form-group userWrapper"  v-click-outside="hideList">
                        <label for="phone" class="form-label">Or find a User</label>
                        <input type="text" class="form-control"
                               placeholder="Type User email or name"
                               v-model="input">
                        <div class="selectedUser" v-if="selectedUser" @click="clearUser()">
                            {{selectedUser.first_name}} {{selectedUser.last_name}} ({{selectedUser.email}})
                        </div>
                        <div v-if="debouncedInput && usersLoaded && !selectedUser" class="userList">
                            <div v-for="user in userList" v-if="userList.length > 0" @click="setUser(user)">
                                {{user.first_name}} {{user.last_name}} ({{user.email}})
                            </div>
                            <div v-if="userList.length === 0">No Results</div>
                        </div>
                    </div>
                </div>
                <div class="previous-orders-wrapper" v-if="previousOrders.length > 0">
                    <div class="row">
                        <h3>Previous orders:</h3>
                        <div class="previous-orders-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            Boat Name
                                        </th>
                                        <th>
                                            Date
                                        </th>
                                        <th>
                                            Price
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="order in previousOrders">
                                        <td>
                                            {{order.name}}
                                        </td>
                                        <td v-if="order.starts_at">
                                            {{ new Date(order.starts_at).toLocaleDateString("en-US", {year:"numeric",month:"2-digit", day:"2-digit"}) }}
                                        </td>
                                        <td>
                                            ${{ order.price }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h3>Order Information:</h3>
        <div class="row">
            <div class="col-sm-6">
                <div class="row">
                    <ValidationProvider class="col-sm-12 mb-3" name="Boat" rules="required" v-slot="{ errors }">
                        <label for="boat" class="form-label">Choose Boat:*</label>
                        <div class="form-group mb-1">
                            <select id="boat" :class="['form-control', {'input-error' : errors[0] }]"
                                    v-model="boat">
                                <option :value="null" disabled>Select Boat</option>
                                <option v-for="boat in boatList" :key="boat.id" :value="boat">
                                    {{ boat.name }}
                                </option>
                            </select>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] }]">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12 mb-3" name="Adults and Children" rules="required" v-slot="{ errors }" v-if="boat">
                        <label for="adult" class="form-label">Number of Adults and Children:*</label>
                        <div class="form-group mb-1">
                            <select id="adult" :class="['form-control', {'input-error' : errors[0] }]"
                                    v-model="form.people_number">
                                <option :value="null" disabled>Select One</option>
                                <option v-for="adult in boatLimit" :key="adult" :value="adult">
                                    {{ adult }}
                                </option>
                            </select>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] }]">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12 mb-3" name="Duration" rules="required" v-slot="{ errors }" v-if="boat">
                        <label for="duration" class="form-label">Choose Duration:*</label>
                        <div class="form-group mb-1">
                            <select id="duration" :class="['form-control', {'input-error' : errors[0] }]"
                                    v-model="duration">
                                <option :value="null" disabled>Select Duration</option>
                                <option v-for="duration in durations" :key="duration.value" :value="duration.value">
                                    {{ duration.name }}
                                </option>
                            </select>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] }]">
                                {{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                    <div class="col-sm-12 mb-4" v-if="duration && boat">
                        <date-picker
                            inline
                            @calendar-change="onMonthChange"
                            :disabled-date="isDisabledDate"
                            v-model="calendar"
                        ></date-picker>
                    </div>
                    <div class="col-sm-12" v-if="duration && boat">
                        <div class="row">
                            <div class="col-sm-6">
                                <label for="start" class="form-label">Starts:</label>
                                <div class="form-group">
                                    <select id="start" class="form-control" v-model="form.start">
                                        <option v-for="i in startTimes" :value="i" >{{ timeFormatFullToHalf(i, 'start') }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label for="start_custom" class="form-label">Custom Starts:</label>
                                <div class="form-group">
                                    <date-picker
                                        id="start_custom"
                                        type="time"
                                        v-model="form.custom_start"
                                    ></date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <label for="" class="form-label">Appointment Notes <em>(optional)</em>:</label>
                        <div class="form-group">
                            <textarea class="form-control" v-model="form.notes"></textarea>
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="!isEdit">
                        <h6>Add to your appointment</h6>
                        <div class="form-group" v-for="addon in addons" :key="addon.id">
                            <div class="form-check">
                                <input class="form-check-input-checkbox" type="checkbox" :id="addon.name" v-model="addon.value" @change="setAddons(addon)">
                                <label class="form-check-label" :for="addon.name">{{ addon.description }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="isEdit && order.additional_options">
                        <h6>Additional Options</h6>
                        <div class="form-group" v-for="addon in JSON.parse(order.additional_options)" :key="addon.id">
                            <label class="form-label">{{addon.description}} - ${{addon.price}}</label>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="total-cost">
                            <div class="row">

                                <div class="col-sm-6">
                                    <strong>Total:</strong>
                                </div>
                                <div class="col-sm-6 text-right">
                                    <p>
                                        <strong>
                                            {{ total | toFixed | toUSD }}
                                        </strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <button class="btn w-100" @click="addOrder" :disabled="!valid() || isUploading">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import PromoCode from "../../../../../PromoCode/resources/js/components/PromoCode";
import promoCode from "../../../../../../../resources/js/mixins/promo-code";

export default {
    name: "AdminOrder",
    props: {
        order: {
            type: Object|Array,
        },
        startDayHour: Number,
        endDayHour: Number,
        cdwPrice: Number,
        captainPrice: Number,
    },
    components: { DatePicker, PromoCode },
    mixins: [ promoCode ],
    data() {
        return {
            form: {
                id: this.order.id,
                first_name: this.order.first_name,
                last_name: this.order.last_name,
                phone: this.order.phone,
                email: this.order.email,
                product_id: this.order.product_id,
                duration: this.order.duration || 2,
                people_number: this.order.people_number,
                start: this.order.starts_at ? new Date(this.order.starts_at).getHours() : this.day_start,
                notes: this.order.notes,
                custom_start: this.order.starts_at ? new Date(this.order.starts_at) : null
            },
            subTotal: this.order.sub_total,
            addons: [
                {
                    id: 1,
                    price: this.cdwPrice,
                    name: 'cdw',
                    value: false,
                    description: 'Collision Damage Waiver (CDW) for damage to the propeller ($200 replacement cost without the waiver) $' + this.cdwPrice,
                },
                {
                    id: 2,
                    price: this.captainPrice,
                    name: 'captain',
                    value: false,
                    description: 'Hire Captain (+$'+this.captainPrice+', subject to availability). Captain fee to be paid directly to the captain in cash on day of rental.',
                }
            ],
            calendar: this.order.starts_at ? new Date(this.order.starts_at) : new Date(),
            boatList: [],
            userList: [],
            previousOrders: [],
            timeout: null,
            debouncedInput: '',
            isEdit: null,
            isUploading: false,
            boat: null,
            day_start: this.startDayHour,
            day_end: this.endDayHour,
            duration: this.order.duration,
            selectedUser: null,
            usersLoaded: false,
            currentPeriodStart: this.getFirstMonthDay(new Date()),
            currentPeriodEnd: this.getLastMonthDay(new Date()),
            disabledDatesArray: [],
            disableTimesArray: [],
            startTimes: this.range(this.day_start, (this.day_end - this.duration)),
            durations: [
                {
                    value: 2,
                    name: '2h',
                },
                {
                    value: 4,
                    name: '4h',
                },
                {
                    value: 6,
                    name: '6h',
                },
                {
                    value: 8,
                    name: '8h',
                }
            ],
        }
    },
    mounted() {
        this.getBoats();
        this.isEdit = !!this.order.id;
    },
    computed: {
        input: {
            get() {
                return this.debouncedInput
            },
            set(val) {
                if (val) {
                    if (this.timeout) clearTimeout(this.timeout)
                    this.timeout = setTimeout(() => {
                        this.debouncedInput = val
                    }, 400)
                }
            }
        },
        boatLimit() {
            return this.boat.limit ? this.boat.limit : 10
        },
        getAddedAddonsValue() {
            return this.addons
                .filter((addon) => !!addon.value)
                .reduce((acc, addon) => acc + addon.price, 0)
        },
        total() {
            return this.order?.total ? this.order.total : this.boat && (this.boat[`price_${this.form.duration}h`] + this.getAddedAddonsValue)
        }
    },
    watch: {
        debouncedInput() {
            this.findUsers(this.debouncedInput)
        },
        selectedUser() {
            if (this.selectedUser) {
                this.form.first_name = this.selectedUser.first_name;
                this.form.last_name = this.selectedUser.last_name;
                this.form.email = this.selectedUser.email;
                this.form.phone = this.selectedUser.phone;
            }
        },
        boat() {
            this.form.product_id = this.boat.id;
            this.getDisableDates(this.currentPeriodStart, this.currentPeriodEnd);
            this.calendar = this.order.starts_at ? new Date(this.order.starts_at) : new Date();
            this.startTimes = this.range(this.day_start, (this.day_end - this.duration));
        },
        // whenever question changes, this function will run
        duration(newDuration, oldDuration) {
            this.form.duration = this.duration;
            this.getDisableDates(this.currentPeriodStart, this.currentPeriodEnd)
            this.calendar = this.order.starts_at ? new Date(this.order.starts_at) : new Date();
            this.startTimes = this.range(this.day_start, (this.day_end - newDuration));
        },
        calendar(newValue, oldValue) {
            const date = new Date(newValue).toLocaleDateString("en-US", {year:"numeric",month:"2-digit", day:"2-digit"})
            const selectedTimeRange = this.disableTimesArray[date];
            if (selectedTimeRange) {
                this.startTimes = selectedTimeRange;
            } else {
                this.startTimes = this.range(this.day_start, (this.day_end - (this.duration)));
            }
        },
    },
    methods: {
        getBoats() {
            axios.get('/products/featured').then((response) => {
                this.boatList = response.data.data;
                if (this.order.product_id) {
                    this.boat = this.boatList.find(item => item.id === this.order.product_id)
                }
            })
        },
        timeFormatFullToHalf(time) {
            let format = 'am';

            if (time > 12) {
                time -= 12;
                format = 'pm'
            }

            return time < 10 ? `0${time}:00 ${format}` : `${time}:00 ${format}`
        },
        range(start, end) {
            const ans = [];
            for (let i = start; i <= end; i++) {
                ans.push(i);
            }
            return ans;
        },
        getFirstMonthDay(date) {
            return new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('sv-SE');
        },
        getLastMonthDay(date) {
            return new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('sv-SE');
        },
        setUser(user) {
            this.selectedUser = user;
            this.usersLoaded = false;
            this.getPreviousOrder()
        },
        clearUser() {
            this.selectedUser = null;
            this.input = '';
            this.debouncedInput = '';
            this.previousOrders = [];
        },
        hideList() {
            this.usersLoaded = false;
        },
        findUsers(query) {
            if (query) {
                this.usersLoaded = false;
                axios.get(`/order/clients?query=${query}`).then((response) => {
                    this.userList = response.data.data;
                    this.usersLoaded = true;
                })
            }
        },
        getPreviousOrder() {
            if (this.selectedUser) {
                axios.get(`/order/archive?user=${this.selectedUser.email}`).then((response) => {
                    console.log(response.data.data)
                    this.previousOrders = response.data.data;
                })
            }
        },
        onMonthChange(date) {
            const start = this.getFirstMonthDay(date);
            const end = this.getLastMonthDay(date);
            this.currentPeriodStart = start;
            this.currentPeriodEnd = end;
            this.getDisableDates(start, end)
        },
        isDisabledDate(date) {
            return !this.duration ||
                date < new Date() ||
                this.disabledDatesArray.includes(date.toLocaleDateString("en-US", {year:"numeric",month:"2-digit", day:"2-digit"}));
        },
        valid() {
            return this.boat &&
                this.form.product_id &&
                this.form.first_name &&
                this.form.last_name &&
                this.form.email &&
                this.form.duration &&
                this.form.phone &&
                this.form.people_number &&
                (this.form.start || this.form.custom_start)
        },
        addOrder() {
            const date = new Date(this.calendar ? this.calendar : new Date());
            let startDate;
            if (this.form.custom_start) {
                const customDate = new Date(this.form.custom_start);
                startDate = new Date(date.setHours(customDate.getHours(), customDate.getMinutes(), customDate.getSeconds(), 0));
            } else {
                startDate = new Date(date.setHours(this.form.start, 0, 0, 0));
            }
            const startAt = startDate.toLocaleString('ru');
            const order = {...this.form}
            delete order.start;
            order['start_at'] = startAt;
            order['location'] = this.boat.location.address;
            order['price'] = this.boat[`price_${this.duration}h`];
            order['total'] = this.total;
            order['sub_total'] = this.subTotal;
            order['additional_options'] = [];
            this.addons.forEach(item => {
                if (item.value) {
                    order['additional_options'].push({
                        description: item.description,
                        price: item.price,
                    })
                }
            });
            this.isUploading = true;
            if (this.isEdit) {
                axios.post(`/order/edit_order`, {
                    order
                }).then(res => {
                    this.isUploading = false;
                    if (res.data && res.data.success) {
                        window.location.replace('/admin/orders/');
                    }
                })
            } else {
                axios.post(`/order/add_order`, {
                    order
                }).then(res => {
                    this.isUploading = false;
                    if (res.data && res.data.success) {
                        window.location.replace('/admin/orders/');
                    }
                })
            }
        },
        getDisableDates(start, end) {
            if (this.boat && this.form.duration) {
                axios.get(`/order/disable-dates/${this.boat.id}/${this.form.duration}/${start}/${end}`).then((response) => {
                    this.disabledDatesArray = response.data.dates;
                    this.disableTimesArray = response.data.periods;
                })
            }
        },
    }
}
</script>

<style>
.order-form-main {
    padding: 30px;
}
.order-form-main .form-group {
    position: relative;
}
.order-form-main .field-validation-error {
    position: absolute;
    bottom: -15px;
    margin: 0;
    font-size: 11px;
    color: red;
}
.order-form-main .row>[class*=col-] {
    margin-bottom: 5px;
}
.order-form-main .userWrapper {
    position: relative;
    width: 100%;
}
.order-form-main .selectedUser {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 34px;
    line-height: 32px;
    padding: 0 13px;
    background: #fff;
    border: 1px solid #e4eaec;
    cursor: pointer;
}
.order-form-main .selectedUser:before {
    content: '';
    position: absolute;
    right: 10px;
    background: #909192;
    width: 15px;
    height: 1px;
    top: 50%;
    transform: rotate(45deg);
}
.order-form-main .selectedUser:after {
    content: '';
    position: absolute;
    right: 10px;
    background: #909192;
    width: 15px;
    height: 1px;
    top: 50%;
    transform: rotate(-45deg);
}
.order-form-main .userList {
    position: absolute;
    left: 0;
    top: 100%;
    background: #fff;
    border: 1px solid #e4eaec;
    width: 100%;
    margin-top: -1px;
    max-height: 160px;
    overflow-y: auto;
}
.userList > div{
    padding: 5px 13px;
    cursor: pointer;
}
.userList > div:hover{
    background: #ececec;
}
.mx-calendar {
    height: auto !important;
}
textarea.form-control {
    resize: none;
    padding-top: 1rem;
    padding-bottom: 1rem;
    height: 8.125rem;
}
.form-check-input-checkbox {
    width: 1.125rem;
    height: 1.125rem;
    position: absolute;
    z-index: 3;
    opacity: 0;
    left: 0;
    top: 0;
}
.form-check-input-checkbox+.form-check-label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 1.125rem;
    height: 1.125rem;
    border-radius: 0;
    background: var(--color-white);
    border: 0.0625rem solid #d9d9d9;
}
.order-form-main .form-check-input-checkbox+.form-check-label:after {
    font: 900 0.8125rem/1.125rem 'Font Awesome 5 Free';
    content: '\f00c';
    position: absolute;
    top: 0;
    left: 0;
    width: 1.125rem;
    height: 1.125rem;
    text-align: center;
    opacity: 0;
    color: var(--color-primary);
}
.order-form-main .form-check-input-checkbox:checked+.form-check-label:after {
    opacity: 1;
}

.order-form-main .form-check-input-checkbox+.form-check-label {
    font-weight: 400;
    padding: 0 0 0 1.75rem;
    margin: 0;
    position: relative;
    font-size: .9375rem;
    line-height: 1.5625rem;
    color: var(--color-text);
    vertical-align: top;
}
.order-form-main .form-check {
    padding: 0;
    margin: 0;
    position: relative;
}
.previous-orders-table {
    width: 100%;
}
.previous-orders-table table{
    width: 100%;
}
.previous-orders-table table td,
.previous-orders-table table th
{
    padding: 5px 10px;
}
.previous-orders-table table tr th
{
    background: #efefef;
}
.previous-orders-table table  td
{
    border-bottom: 1px solid #efefef;
}
.mx-datepicker {
    width: 100%;
}
</style>
